import gql from "graphql-tag";
const getLabsDataQuery = {
query: gql(` 
query getLabsData($userid: String!) {
  getLabsData(userid: $userid) {
  feature
  } 
}   
`),
mfa: false
}
export default getLabsDataQuery
